// @ts-nocheck
/* eslint-disable */
/* GENERATED USING build-GemIcons.ts - DO NOT MODIFY */
import { ReactComponent as LogoDatabricks } from '../../../assets/images/Logos/logo-databricks.svg?react';
import { withLogoClass } from '../../withLogoClass';
export const LogoDatabricksIcon = /* @__PURE__ */ withLogoClass(LogoDatabricks);
